var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#A8ADB2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49066 0C11.6376 0 15 3.36239 15 7.49066C15 11.6376 11.6376 15 7.49066 15C3.36239 15 0 11.6376 0 7.49066C0 3.36239 3.36239 0 7.49066 0ZM7.49066 6.44458L9.99377 3.96015L11.0399 5.00623L8.55542 7.49066L11.0399 9.99377L9.99377 11.0399L7.49066 8.55542L5.00623 11.0399L3.96015 9.99377L6.44458 7.49066L3.96015 5.00623L5.00623 3.96015L7.49066 6.44458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2963b9b41096be19f4ff708839164b12.svg";
export { ForwardRef as ReactComponent };